import { useCallback, useState } from "react";
import { Avatar, Flex, Text } from "@mantine/core";
import { IconUpload, IconX } from "@tabler/icons-react";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { uploadContentImage } from "./contentApi";
import { rem } from "@mantine/core";
import { useBrandContext } from "../Brands/brandContext";

function ContentAssetUploader({ mimeType, onUploadComplete, message, image }) {
  const [isUploading, setIsUploading] = useState(false);
  const { selectedBrand } = useBrandContext();

  const onDrop = useCallback(
    (acceptedFiles) => {
      setIsUploading(true);
      const file = acceptedFiles[0];
      uploadContentImage(file, selectedBrand?.id)
        .then((data) => {
          // this returns the entire profile
          setIsUploading(false);
          onUploadComplete(data);
        })
        .catch((err) => {
          // TBD: Show user-friendly message
          setIsUploading(false);
          console.error(err);
        });
    },
    [isUploading]
  );

  return (
    <div style={{ position: "relative" }}>
      <Dropzone
        disabled={!selectedBrand}
        onDrop={onDrop}
        onReject={(files) => console.log("rejected files", files)}
        maxSize={4 * 1024 ** 2}
        accept={[MIME_TYPES.jpeg, MIME_TYPES.png]}
        loading={isUploading}
      >
        <Flex
          m="md"
          align="center"
          justify="center"
          mih={90}
          style={{ pointerEvents: "none" }}
        >
          <Dropzone.Accept>
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconUpload size={55} stroke={1.8} />
            </Avatar>
          </Dropzone.Accept>
          <Dropzone.Reject component="div">
            <Avatar
              size="xl"
              color="white"
              style={{ position: "absolute", zIndex: 22 }}
            >
              <IconX
                style={{
                  width: rem(52),
                  height: rem(52),
                  color: "var(--mantine-color-red-6)",
                }}
                stroke={1.8}
              />
            </Avatar>
          </Dropzone.Reject>
          <div>
            {image ? (
              image
            ) : (
              <Text size="xl" inline>
                {message}
              </Text>
            )}
          </div>
        </Flex>
      </Dropzone>
    </div>
  );
}

export default ContentAssetUploader;
